import {
    request,
    requestPublic
} from './request.js'
// 获取普本专业列表
export function getMajorPtList(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/MajorPt/GetMajorPtList',
        method: 'get',
        params: {
            MajorId: obj.majorId,
            SchoolId: obj.schoolId,
            MajorCategoryId: obj.majorCategoryId,
            Year: obj.year,
            Name: obj.name,
            pageIndex: obj.pageIndex,
            pageSize: obj.pageSize,
        }
    })
}

// 新增普本专业
export function addMajorPt(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/MajorPt/AddMajorPt',
        method: 'post',
        data: data
    })
}

// 修改普本专业
export function updateMajorPt(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/MajorPt/UpdateMajorPt',
        method: 'post',
        data: data
    })
}

// 删除普本专业
export function delMajorPt(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/MajorPt/DelMajorPt',
        method: 'post',
        params: {
            id: id
        }
    })
}
//获取指定条件普本专业
export function getMajorPtSchoolList(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/MajorPt/GetMajorPtSchoolList',
        method: 'get',
        params: {
           Id: obj.majorId,
            Name: obj.name,
            MajorCategoryId: obj.majorCategoryId,
            Year: obj.year,
            PageSize: obj.pageSize,
        }
    })
}